"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const validator = require("validator");
const react_redux_1 = require("react-redux");
const react_bootstrap_1 = require("react-bootstrap");
const util_1 = require("util");
const utils_1 = require("../utils");
const AuthenticationActions_1 = require("../authentication/AuthenticationActions");
const constants_1 = require("../constants");
const Loader_1 = require("../shared/Loader");
const api_1 = require("../api");
const { V_LOYAL_REACH } = require('../../../config');
function mapDispatchToProps(dispatch) {
    return {
        loginSuccess: payload => dispatch(AuthenticationActions_1.loginSuccess(payload)),
        dispatch
    };
}
function mapStateToProps(state = constants_1.INITIAL_STATE) {
    return {
        loginProgress: state.landingPage.loginProgress,
        loginErrors: state.landingPage.loginErrors
    };
}
class OrganizationUserSetupComponent extends React.Component {
    constructor(props) {
        super(props);
        this.password = "";
        this.submit = this.submit.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.state = {
            state: constants_1.ProgressState.Loading,
            shouldUpdate: true,
            joinRequest: null
        };
    }
    componentDidMount() {
        document.body.scrollTop = 0;
    }
    scriptsLoaded() {
        api_1.doGet(api_1.API.v2.ORGANIZATION.REQUESTS.GET_BY_TOKEN(this.props.params.token)).then(response => {
            this.setState({
                state: constants_1.ProgressState.Success,
                joinRequest: response.data.response
            });
        }).catch(error => {
            api_1.handleError(error);
        });
    }
    submit() {
        return __awaiter(this, void 0, void 0, function* () {
            $('.help-block').empty();
            if (!this.isValid()) {
                return;
            }
            this.setState({ shouldUpdate: true });
            const request = yield api_1.doPost(api_1.API.v2.ORGANIZATION.REQUESTS.FINALIZE(), {
                token: this.props.params.token,
                password: this.password
            });
            this.props.loginSuccess({
                user: request.data.response.user,
                accessToken: request.data.response.access_token,
                socials: request.data.response.socials,
                organization: request.data.response.user.organization
            });
            window.location.replace(`/${request.data.response.user.organization.routePrefix}/app`);
        });
    }
    handleKeyPress(target) {
        if (target.charCode !== 13) {
            return;
        }
        this.submit();
    }
    componentDidUpdate() {
        if (!this.props.loginErrors) {
            return;
        }
        this.props.loginErrors.map(err => {
            if (err.reason == "LOGIN_FAILED") {
                this.setState({
                    password: {
                        state: constants_1.ProgressState.Failed,
                        errorMessage: this.state.password.errorMessage
                    },
                    errorBlock: {
                        state: constants_1.ProgressState.Failed,
                        errorMessage: "Email or password was incorrect"
                    },
                    shouldUpdate: false,
                    state: constants_1.ProgressState.Failed,
                    button: "danger"
                });
            } else if (err.reason == "USER_NOT_ACTIVATED") {
                this.setState({
                    password: {
                        state: constants_1.ProgressState.Failed,
                        errorMessage: this.state.password.errorMessage
                    },
                    errorBlock: {
                        state: constants_1.ProgressState.Failed,
                        errorMessage: "User not activated"
                    },
                    shouldUpdate: false,
                    state: constants_1.ProgressState.Failed,
                    button: "danger"
                });
            }
        });
    }
    shouldComponentUpdate() {
        return this.state.shouldUpdate;
    }
    render() {
        let buttonStyle = "primary";
        let setupFailed;
        if (this.state.state == constants_1.ProgressState.Failed) {
            setupFailed = utils_1.FormUtils.showErrorBlock(this.state.errorBlock);
            if (this.state.button == "danger") {
                buttonStyle = "danger";
            }
        }
        return React.createElement("div", null, React.createElement("link", { href: `/css/main.css?V_LOYAL_REACH=${V_LOYAL_REACH}`, rel: "stylesheet" }), React.createElement(Loader_1.default, { libraries: [], onLoad: () => this.scriptsLoaded() }), React.createElement(react_bootstrap_1.Row, { className: "flex-center flex-horizontal-center pt-120" }, React.createElement(react_bootstrap_1.Col, { xs: 12, md: 8 }, React.createElement(react_bootstrap_1.Panel, { className: "login-panel organization-auth-panel" }, React.createElement("div", { className: "panel-body" }, React.createElement("h2", { className: "text-center" }, "Please Complete User Setup"), React.createElement("div", { className: "text-center has-error" }, setupFailed), React.createElement("fieldset", null, this.state.joinRequest && this.state.joinRequest.userEmail && React.createElement(react_bootstrap_1.FormGroup, { controlId: "organizationName" }, React.createElement(react_bootstrap_1.FormControl, { placeholder: "Organization Name", name: "organizationName", type: "text", defaultValue: this.state.joinRequest.userEmail, disabled: true })), this.state.joinRequest && this.state.joinRequest.userName && React.createElement(react_bootstrap_1.FormGroup, { controlId: "name" }, React.createElement(react_bootstrap_1.FormControl, { placeholder: "Name", name: "name", type: "text", defaultValue: this.state.joinRequest.userName, disabled: true })), this.state.joinRequest && this.state.joinRequest.userPhone && React.createElement(react_bootstrap_1.FormGroup, { controlId: "phone" }, React.createElement(react_bootstrap_1.FormControl, { placeholder: "Phone", name: "phone", type: "text", defaultValue: this.state.joinRequest.userPhone, disabled: true })), React.createElement(react_bootstrap_1.FormGroup, Object.assign({ controlId: "password" }, utils_1.FormUtils.formGroupAttributes(this.state.password)), React.createElement(react_bootstrap_1.FormControl, { placeholder: "Password", name: "password", type: "password", onKeyPress: this.handleKeyPress, onChange: event => utils_1.FormUtils.dataChanged(event, this) }), utils_1.FormUtils.showErrorBlock(this.state.password)), React.createElement(react_bootstrap_1.FormGroup, Object.assign({ controlId: "confirmPassword" }, utils_1.FormUtils.formGroupAttributes(this.state.confirmPassword)), React.createElement(react_bootstrap_1.FormControl, { placeholder: "Confirm your Password", name: "confirmPassword", type: "password", onKeyPress: this.handleKeyPress, onChange: event => utils_1.FormUtils.dataChanged(event, this) }), utils_1.FormUtils.showErrorBlock(this.state.confirmPassword)), React.createElement("br", null), React.createElement(react_bootstrap_1.Button, { className: "modal-button organization-login-button", title: "Sign in", bsStyle: buttonStyle, onClick: this.submit }, "Submit")), React.createElement("br", null), React.createElement("br", null))))));
    }
    isValid() {
        let valid = true;
        if (util_1.isNullOrUndefined(this.password) || validator.isEmpty(this.password)) {
            this.setState({
                password: {
                    state: constants_1.ProgressState.Failed,
                    errorMessage: "Password can't be blank."
                },
                button: "danger"
            });
            valid = false;
        } else if (util_1.isNullOrUndefined(this.confirmPassword) || validator.isEmpty(this.confirmPassword)) {
            this.setState({
                confirmPassword: {
                    state: constants_1.ProgressState.Failed,
                    errorMessage: "Confirmation Password can't be blank."
                },
                button: "danger"
            });
            valid = false;
        } else if (this.confirmPassword !== this.password) {
            this.setState({
                confirmPassword: {
                    state: constants_1.ProgressState.Failed,
                    errorMessage: "Confirmation Password should match Password"
                },
                button: "danger"
            });
            valid = false;
        } else {
            this.setState({
                password: {
                    state: constants_1.ProgressState.Success
                },
                confirmPassword: {
                    state: constants_1.ProgressState.Success
                }
            });
        }
        return valid;
    }
}
const OrganizationUserSetup = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(OrganizationUserSetupComponent);
exports.default = OrganizationUserSetup;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/OrganizationUserSetup.tsx
// module id = 1351
// module chunks = 0 1